import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-image-upload ',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {
    @Input() isRound = false;
    @Input() image: string;
    @Output() fileChanged: EventEmitter<File>;
    state: any = {};
    constructor() {
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.fileChanged = new EventEmitter();
    }

    ngOnInit() {
        this.state = {
            file: null,
            imagePreviewUrl: this.image !== undefined ? this.image :
              (this.isRound ? './assets/img/placeholder.jpg' : './assets/img/image_placeholder.jpg')
        };
    }
    handleImageChange(e) {
        e.preventDefault();
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onloadend = () => {
            this.state.file = file;
            this.state.imagePreviewUrl = reader.result;
            // this.state.imagePreviewUrl1 = reader.result;
        };
        reader.readAsDataURL(file);
        console.log('file is ', reader.result);
        this.fileChanged.emit(file);
    }
    handleSubmit(e) {
        e.preventDefault();
        // this.state.file is the file/image uploaded
        // in this function you can save the image (this.state.file) on form submit
        // you have to call it yourself
    }
    handleClick() {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = this.handleImageChange;
        input.click();
    }
    handleRemove() {
        this.state.file = null;
        this.state.imagePreviewUrl = this.image !== undefined ? this.image :
          (this.isRound ? './assets/img/placeholder.jpg' : './assets/img/image_placeholder.jpg');
        this.fileChanged.emit(null);
    }
}
